import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item", "moreButton"];
  static values = {
    initialCount: { type: Number, default: 3 },
    incrementCount: { type: Number, default: 5 }
  };

  connect() {
    this.visibleCount = this.initialCountValue;
    this.updateVisibility();
  }

  showMore() {
    this.visibleCount += this.incrementCountValue;
    this.updateVisibility();
  }

  updateVisibility() {
    const items = this.itemTargets;
    const totalCount = items.length;

    items.forEach((item, index) => {
      if (index < this.visibleCount) {
        item.classList.remove("is-hidden");
      } else {
        item.classList.add("is-hidden");
      }
    });

    // 全件表示したらボタンを非表示
    if (this.hasMoreButtonTarget) {
      if (this.visibleCount >= totalCount) {
        this.moreButtonTarget.classList.add("is-hidden");
      } else {
        this.moreButtonTarget.classList.remove("is-hidden");
      }
    }
  }
}
